<template>
    <div class="searchResults">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="search_box">
                <b-nav-form>
                    <b-form-input size="sm" class="" type="text" placeholder="搜尋關鍵字" v-model="keyword" autocomplete="off" />
                    <b-button size="sm" class="login_search" type="button" @click="seach"></b-button>
                </b-nav-form>
            </div>
            <div class="products collection" v-if="searchList.length">
                <ProductItemBox :products="searchList" :products_title="title" />
            </div>
            <div class="products collection" v-else>
                <div class="cantsearch">
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <img :src="require(`@/assets/images/icon/noteice.svg`)">
                        </div>
                        <div class="col-10 col-lg-auto align-self-center">
                            很抱歉，找不到符合 「 {{ title }} 」的相關商品，以下是相關課程。
                        </div>
                    </div>
                </div>
                <!-- <ProductItemBox :products="featureList" :products_title="'相關結果'" /> -->
            </div>
            <!-- <loadmore /> -->
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import ProductItemBox from '@/components/products/items/ItemBox'
    import Loadmore from '@/components/partial/Loadmore'
    import classApi from '@/api/class'
    import searchMixin from '@/mixins/search'
    import userMixin from '@/mixins/user'

    export default {
        mixins:[searchMixin, userMixin],
        name:'searchResults',
        props: {
            searchKeyword: {
                type: String,
                required: true,
            },
        },
        data(){
            return{
                crumbsItem: [{
                    text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: '搜尋結果',
                        active: true
                    }
                ],
                currentPage: 1,
                perPage: 6,
                lastPage: true,
                searchList: [],
                featureList: [],
                keyword:'',
            }
        },
        components: {
            Breadcrumbs,
            ProductItemBox,
            Loadmore,
        },
        created() {
            this.getData()
        },
        watch: {
            searchKeyword(val) {
                this.keyword = val
                this.getData()
            }
        },
        computed: {
            title() {
                return `"${this.searchKeyword}"搜尋結果`
            }
        },
        methods: {
            initUser() {
                this.getData(); 
            },
            getData() {
                this.getSearch()
            },
            getSearch() {
                if (!this.searchKeyword){
                    this.getQueryFeatured()
                    return
                }
                this.searchList = [];
                classApi.search({
                    KeyWord: this.searchKeyword
                }, (data) => {
                    this.searchList = data ? data : [];
                    if (!this.searchList.length) { 
                        this.getQueryFeatured()
                    }
                });
            },
            getQueryFeatured() {
                // this.featureList = [];
                // classApi.queryFeatured({}, (data) => {
                //     this.featureList = data ? data : [];
                // });
            },
        },
    }
</script>

